import * as L from 'leaflet';

export const esriApiKey = 'AAPK7f9cd92d9d53466a8128cc4f70e5ad5ewG-RKdxd7WEL8PpXEB_BmsZ5-lRs8yvUJx4r8xk2MUEEy4o87F-mo41lL8UH6qxY';

export class DataMarker<T> extends L.Marker {
  public data: T;

  constructor(latLng: L.LatLngExpression, data: T, options?: L.MarkerOptions) {
    super(latLng, options);
    this.data = data;
  }
}
